import React from "react"
import type { CSSProperties, ElementType, ReactNode } from "react"
import cx from "classnames"

export const labelClasses =
  "text-sm font-semibold font-sans leading-5 text-gray-800"

type LabelProps = {
  /** If a `Label` has an associated element, pass the `id` of the element as `htmlFor`. */
  htmlFor?: string
  /** Label content */
  children?: ReactNode
  /** Additional CSS classes */
  className?: string
  /** HTML element to render as */
  as?: ElementType
  /** HTML id attribute for accessibility (e.g. aria-labelledby) */
  id?: string
  /** Click handler, e.g. to focus a non-input trigger element */
  onClick?: React.MouseEventHandler
  /** @deprecated Avoid inline styles */
  style?: CSSProperties
}

/**
 * A text label for form elements and other UI sections.
 * Renders as a `<label>` by default but can be changed via the `as` prop.
 */
function Label({
  htmlFor,
  children,
  className,
  as: Component = "label",
  id,
  onClick,
  style
}: LabelProps) {
  return (
    <Component
      className={cx(labelClasses, className)}
      htmlFor={htmlFor}
      id={id}
      onClick={onClick}
      style={style}
    >
      {children}
    </Component>
  )
}

export { Label }
export default Label
